"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var blockWidthMappings = {
    small: "60%",
    medium: "75%",
    large: "90%",
};
exports.default = blockWidthMappings;
